import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from "material-ui";
import Subheader from 'material-ui/Subheader';
import {connect} from "react-redux";
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import {fetchApp} from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './EditMediaPage.css';
import {fetchPoint, putPointMedia, fetchPointMedia} from "../../../store/points/actions";
import {getMediaTypes} from "../../../store/mediatypes/actions";
import MediaForm from "../../../components/media/MediaForm/MediaForm";
import {EntityType} from "../../../constants/openexplore";
import {fetchTrail, fetchTrailMedia, putTrailMedia} from "../../../store/trails/actions";
import withTranslation from "../../../hoc/withTranslation";

export class EditMediaPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        point: PropTypes.object,
        media: PropTypes.object
    };

    static defaultProps = {
        mediaTypes: []
    };

    componentWillMount() {
        this.fetch();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetch(nextProps.match.params.appId, nextProps.match.params.entityId, nextProps.match.params.mediaId)
        }

        if (this.props.sending && !nextProps.sending) {
            this.props.history.goBack();
        }

        if (nextProps.app && this.props.mediaTypes.count === 0) {
            this.fetchMediaTypes(nextProps.app.id);
        }

        if (nextProps.app && this.props.app !== nextProps.app && this.props.entity === null) {
            this.fetchEntity(nextProps.app.id, nextProps.match.params.entityId);
        }

        if (nextProps.app && nextProps.entity && this.props.entity !== nextProps.entity) {
            this.fetchMedia(nextProps.app.id, nextProps.entity.id, nextProps.match.params.mediaId);
        }

    }

    // Fetch

    fetch(appId = null, entityId = null, mediaId = null) {
        this.fetchApplication(appId);
        this.fetchEntity(appId, entityId);
        this.fetchMedia(appId, entityId, mediaId);
        this.fetchMediaTypes(appId);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    fetchEntity(appId = null, entityId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const entity = entityId || this.props.match.params.entityId;

            if (app && entity) {
                switch (this.props.match.params.entityType) {
                    case EntityType.POINT:
                        this.props.fetchPoint(app, entity, this.props.lang);
                        break;

                    case EntityType.TRAIL:
                        this.props.fetchTrail(app, entity, this.props.lang);
                        break;

                    default:
                        break;
                }
            }
        }
    }

    fetchMediaTypes(appId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;

            if (app) {
                this.props.getMediaTypes(app);
            }
        }
    }

    fetchMedia(appId = null, entityId = null, mediaId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const entity = entityId || this.props.match.params.entityId;
            const media = mediaId || this.props.match.params.mediaId;

            if (app && entity && media) {
                switch (this.props.match.params.entityType) {
                    case EntityType.POINT:
                        this.props.fetchPointMedia(app, entity, media, this.props.lang);
                        break;

                    case EntityType.TRAIL:
                        this.props.fetchTrailMedia(app, entity, media, this.props.lang);
                        break;

                    default:
                        break;
                }
            }
        }
    }

    // Actions

    handleFormSubmit = (formProps) => {
        switch (this.props.match.params.entityType) {
            case EntityType.POINT:
                this.props.putPointMedia(this.props.app.id, this.props.entity.id, formProps, this.props.lang);
                break;

            case EntityType.TRAIL:
                this.props.putTrailMedia(this.props.app.id, this.props.entity.id, formProps, this.props.lang);
                break;

            default:
                break;
        }
    };

    // Render

    renderForm() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">

                <Paper style={styles.editBox}>
                    <Subheader style={style.subHeader}>{this.props.media.picture}</Subheader>
                    <div style={style.paper}>
                        <MediaForm
                            onSubmit={this.handleFormSubmit}
                            initialValues={this.props.initialValues}
                            submitting={this.props.sending}
                            media={this.props.media}
                            mediaTypes={this.props.mediaTypes}
                        />
                    </div>
                    <div style={style.clear} />
                </Paper>
            </div>
        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.entity || !this.props.media) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t('medias.media')} / {this.props.t('generic.edit')} - {this.props.entity.name} - {this.props.media.name} ({this.props.media.mime_type})</h3>
                    <div className="row">
                        {this.renderForm()}
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending || state.points.pending || state.mediaTypes.pending || state.trails.pending,
        error: state.points.error || state.apps.error || state.trails.error,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        sending: state.points.sending || state.trails.sending,
        mediaTypes: state.mediaTypes.content,
    };

    switch (ownProps.match.params.entityType) {
        case EntityType.POINT:
            props.entity = state.points.currentPoint;
            props.media = state.points.currentMedia;
            break;

        case EntityType.TRAIL:
            props.entity = state.trails.currentTrail;
            props.media = state.trails.currentMedia;
            break;

        default:
            break;
    }

    if (props.media) {
        props.initialValues = props.media;
    }

    return props;
}

export default connect(mapStateToProps, {
    getMediaTypes,
    putPointMedia,
    putTrailMedia,
    fetchApp,
    fetchTrail,
    fetchTrailMedia,
    fetchPoint,
    fetchPointMedia
})(withTranslation(EditMediaPage));



// WEBPACK FOOTER //
// src/containers/openexplore/EditMediaPage/EditMediaPage.js